var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function transformExchangeRates(id, _a) {
    var exchangeCurrencies = _a.exchangeCurrencies;
    return {
        id: id,
        from: Object.entries(exchangeCurrencies).reduce(function (acc, _a) {
            var _b;
            var from = _a[0], entry = _a[1];
            if (entry) {
                var value = entry[id];
                if (value !== undefined) {
                    return __assign({}, acc, (_b = {}, _b[from] = value, _b));
                }
            }
            return acc;
        }, {}),
    };
}
